var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinterest({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.13637 0.509734C5.96476 0.872501 2.80432 3.50161 2.67388 7.25721C2.59189 9.55028 3.22733 11.2706 5.35727 11.7536C6.28155 10.083 5.05911 9.71448 4.86904 8.50589C4.08825 3.55316 10.4445 0.175606 13.7708 3.63335C16.0722 6.02762 14.5572 13.3937 10.8452 12.6281C7.28968 11.8968 12.5856 6.03334 9.74759 4.88204C7.44062 3.94648 6.21446 7.74408 7.30831 9.63047C6.66728 12.8744 5.28646 15.9312 5.8455 19.9999C7.65864 18.6519 8.26986 16.0705 8.77113 13.3784C9.68237 13.9455 10.1687 14.5355 11.3315 14.6271C15.6194 14.967 18.0139 10.2414 17.4288 5.88251C16.9089 2.01808 13.1447 0.0515013 9.13637 0.509734Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterest);
export default __webpack_public_path__ + "static/media/pinterest.0d036402243fa3878158d14ff17f89e7.svg";
export { ForwardRef as ReactComponent };